import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../../assets/img/MSB-logo.png";
import { Link, useLocation } from 'react-router-dom';
import { useState } from "react";
import "./Header.css";
import Halal from "../../assets/img/halal.svg";

function Header() {
    const [nav, setNav] = useState(false);
    const [expanded, setExpanded] = useState(false);
    // Scroll Navbar
    const changeValueOnScroll = () => {
        const scrollValue = document?.documentElement?.scrollTop;
        scrollValue > 100 ? setNav(true) : setNav(false);
    };

    window.addEventListener("scroll", changeValueOnScroll);
    const location = useLocation();
    return (
        <header>
            <Navbar bg="light" data-bs-theme="light" sticky="top" className='contact-nav'>
                <Container>
                    <div className='d-flex align-items-center contact'>
                        <Navbar.Brand href="#home"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" className='me-2'>
                            <path d="M16 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H16M20 3H18C17.4696 3 16.9609 3.21071 16.5858 3.58579C16.2107 3.96086 16 4.46957 16 5V19C16 19.5304 16.2107 20.0391 16.5858 20.4142C16.9609 20.7893 17.4696 21 18 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 14V14.01M9 14V14.01M6 14V14.01M12 17V17.01M9 17V17.01M6 17V17.01M12 8H6V11H12V8Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                            0116 507 9757</Navbar.Brand>
                        <Navbar.Brand href="#home"><i class="bi bi-telephone"></i> +44 7350 037779</Navbar.Brand>
                        <Navbar.Brand href="#home"><i class="bi bi-envelope"></i> MAGICSPICESBITES@GMAIL.COM</Navbar.Brand>
                    </div>
                    <Nav>
                        <Nav.Link href="https://www.facebook.com/share/1URU5tBuKu/?mibextid=wwXIfr" target='_blank' rel="noreferrer"><i class="bi bi-facebook"></i></Nav.Link>
                        <Nav.Link href="https://www.instagram.com/magic_spice_bites/?igsh=MXBzbzdqZXNpM2ZwZw#" target='_blank' rel="noreferrer"><i class="bi bi-instagram"></i></Nav.Link>
                    </Nav>
                </Container>
            </Navbar>

            <Navbar data-bs-theme="light" sticky="top"
                collapseOnSelect
                expand="md"
                className={`${nav === true ? "sticky menu-nav" : "menu-nav"}`}
            >
                <Container>
                    <Navbar.Brand href="#home">
                        <Link to="/" className="logo">
                            <img src={Logo} alt="Logo" className="img-fluid" width={170} />
                        </Link>
                    </Navbar.Brand>
                    <img src={Halal} width={35} alt='Halal' className='d-block d-md-none' />
                    <Navbar.Toggle
                        aria-controls="responsive-navbar-nav"
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        {expanded ? (
                            <i className="bi bi-x"></i>
                        ) : (
                            <i className="bi bi-list-nested"></i>
                        )}
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav>
                            <Nav.Link as={Link} to="/" active={location.pathname === '/'}>Home</Nav.Link>
                            <Nav.Link as={Link} to="/menu" active={location.pathname === '/menu'}>Our Menu</Nav.Link>
                            <Nav.Link as={Link} to="/location" active={location.pathname === '/location'}>Location &  Contact</Nav.Link>
                        </Nav>
                        <div className='d-block d-md-none'>
                            <hr />
                            <Nav className='mb-3 mobile-contact-nav'>
                                <div className='mobile-nav-icons'>
                                    <a href="https://www.facebook.com/share/1URU5tBuKu/?mibextid=wwXIfr" target='_blank' rel="noreferrer"><i class="bi bi-facebook"></i></a>
                                    <a href="https://www.instagram.com/magic_spice_bites/?igsh=MXBzbzdqZXNpM2ZwZw#" target='_blank' rel="noreferrer"><i class="bi bi-instagram"></i></a>
                                </div>
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" className='me-2'>
                                    <path d="M16 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H16M20 3H18C17.4696 3 16.9609 3.21071 16.5858 3.58579C16.2107 3.96086 16 4.46957 16 5V19C16 19.5304 16.2107 20.0391 16.5858 20.4142C16.9609 20.7893 17.4696 21 18 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3Z" stroke="#000000a6" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 14V14.01M9 14V14.01M6 14V14.01M12 17V17.01M9 17V17.01M6 17V17.01M12 8H6V11H12V8Z" stroke="#000000a6" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>  0116 507 9757</div>
                                <div><i class="bi bi-telephone fw-bold"></i> +44 7350 037779</div>
                                <div><i class="bi bi-envelope"></i> MAGICSPICESBITES@GMAIL.COM</div>
                            </Nav>
                        </div>
                    </Navbar.Collapse>
                    <img src={Halal} width={40} alt='Halal' className='d-none d-md-block' />
                </Container>
            </Navbar>
        </header>

    )
}

export default Header